import { render, staticRenderFns } from "./WaybillItemBatchEdit.vue?vue&type=template&id=53a03efc&"
import script from "./WaybillItemBatchEdit.vue?vue&type=script&lang=js&"
export * from "./WaybillItemBatchEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports